import * as z from "zod/v4";
import { boolean, object, string } from "zod/v4";
const ConciergeTreatmentSettingsSchema_ = object({
  productConciergeEnabled: boolean(),
});
export const ConciergeTreatmentSettingsSchema: z.ZodType<ConciergeTreatmentSettings> =
  ConciergeTreatmentSettingsSchema_;
export type ConciergeTreatmentSettings = z.infer<
  typeof ConciergeTreatmentSettingsSchema_
>;

const ValidatedConciergeTreatmentSchema_ = object({
  id: string(),
  settings: ConciergeTreatmentSettingsSchema_,
  weight: z.number(),
});
export const ValidatedConciergeTreatmentSchema: z.ZodType<ValidatedConciergeTreatment> =
  ValidatedConciergeTreatmentSchema_;
export type ValidatedConciergeTreatment = z.infer<
  typeof ValidatedConciergeTreatmentSchema_
>;
